import { useSelector } from 'store';
import useAuth from './useAuth';
import useSendEmailById from './useSendEmailById';
import getNotification from 'utils/getNotificaton';
import isCapturingDevNotifications from 'utils/isCapturingDevNotifications';
import { AppNotification } from 'types/notification';

export default function useCreateSingleNotification() {
  const { db, user } = useAuth();
  const sendEmailById = useSendEmailById();
  const currentEvent = useSelector((state) => state.currentEvent);

  const createSingleNotification = async (id: string, notificationName: string, context?: { taskTitle?: string }) => {
    const contactRef = db.collection('contacts');
    let message = getNotification(notificationName, currentEvent, context);

    const contact = await contactRef
      .doc(id)
      .get()
      .then((doc) => doc.data());
    const isTalentContact = Array.isArray(contact?.accountTypes) && contact.accountTypes.includes('Talent');
    const shouldForceTaskAssignmentEmail = notificationName === 'Assigned To' && isTalentContact;

    const wouldEmail = shouldForceTaskAssignmentEmail || contact?.notificationSubscriptionsEmail?.includes(notificationName);

    // --- DEV CAPTURE (see utils/isCapturingDevNotifications) ---
    // In dev with the config flag on, don't deliver — just log a summary and bail.
    if (await isCapturingDevNotifications(db)) {
      // eslint-disable-next-line no-console
      console.groupCollapsed(`[DEV] Notification captured — NOT sent: "${notificationName}"`);
      // eslint-disable-next-line no-console
      console.log('Recipient:', { id, name: contact?.name, email: contact?.email1 });
      // eslint-disable-next-line no-console
      console.log('Subject:', message.subject);
      // eslint-disable-next-line no-console
      console.log('HTML:', message.html);
      // eslint-disable-next-line no-console
      console.log('Would send email:', !!wouldEmail);
      // eslint-disable-next-line no-console
      console.groupEnd();
      return;
    }

    const toAdd: AppNotification = {
      ...message,
      createdBy: user?.name,
      status: 'unread',
      timestamp: new Date()
    };

    try {
      contactRef.doc(id).collection('notifications').add(toAdd);
      if (wouldEmail) {
        message.html = message.html.replace(/\n/g, '<br>');
        await sendEmailById({ targetId: id, message });
      }
    } catch (error) {
      console.error('Error creating single notification', error);
    }
  };

  return createSingleNotification;
}
